import { render, staticRenderFns } from "./OpenMethods.vue?vue&type=template&id=4701aced&"
import script from "./OpenMethods.vue?vue&type=script&lang=js&"
export * from "./OpenMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4701aced')) {
      api.createRecord('4701aced', component.options)
    } else {
      api.reload('4701aced', component.options)
    }
    module.hot.accept("./OpenMethods.vue?vue&type=template&id=4701aced&", function () {
      api.rerender('4701aced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/OpenMethods.vue"
export default component.exports